// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import { useEffect, useState } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import SelectMenu from "../../../controls/SelectMenu";

import Input from "../../../controls/Input";
import { classNames } from "../../../../shared/utility";
import { resolveUnitOfMeasureLabel } from "../../../../shared/traceabilityFormatting";

const conditionTypes = [
  { value: 0, label: "Choose Condition" },
  { value: 1, label: "Satisfactory" },
  { value: 2, label: "NOT Satisfactory" },
];

const initialFValues = {};
export default function ReceivingAssemblyItemDetails(props) {
  const {
    onGenerateBarcodePdf,
    receivingItem,
    setOpen,
    updateReceivingAssemblyCall,
  } = props;

  const [createBarcodeInProgress, setCreateBarcodeInProgress] = useState(false);
  const [updateInProgress, setUpdateInProgress] = useState(false);

  const { values, setValues, errors, handleInputChange } = useForm(
    initialFValues,
    false,
  );

  const handleSubmit = async function (e) {
    e.preventDefault();

    setUpdateInProgress(true);
    await updateReceivingAssemblyCall(values, values.receiving_item_id);
    setUpdateInProgress(false);
  };

  useEffect(() => {
    setValues(receivingItem);
  }, [receivingItem, setValues]);

  const generateBarcodeStringClicked = async function () {
    setCreateBarcodeInProgress(true);
    const callResult = await onGenerateBarcodePdf({
      receiving_item_id: values.receiving_item_id,
    });
    setCreateBarcodeInProgress(false);

    if (callResult.success) {
      setTimeout(() => {
        window.print();
      }, 1500);
    }
  };

  const unitOfMeasureLabel = resolveUnitOfMeasureLabel(
    values.unit_of_measure,
    values.unit_of_measure_label,
  );
  const receivedQuantity = Number(values.received_amount);
  const unitCost = Number(values.unit_cost);
  const totalCost =
    Number.isFinite(receivedQuantity) && Number.isFinite(unitCost)
      ? receivedQuantity * unitCost
      : null;

  return (
    <div className="hide-for-print flex h-full flex-col divide-y divide-[#E2E8F0] bg-white">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-[#0F172A]">
              Edit Receiving item
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-[#64748B] hover:text-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <Input
                label="Barcode"
                name="barcode"
                onChange={handleInputChange}
                value={values.barcode}
                labelOn={true}
                disabled={true}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-4">
            <div>
              <Input
                label="Product name"
                name="assembly_item.product_name"
                onChange={handleInputChange}
                value={values?.assembly_item?.product_name}
                labelOn={true}
                type="text"
                disabled={true}
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
              />
            </div>
            <div>
              <Input
                label="Manufacturer"
                name="assembly_item.manufacturer.name"
                onChange={handleInputChange}
                value={values?.assembly_item?.manufacturer?.name}
                labelOn={true}
                disabled={true}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
              />
            </div>
          </div>

          <div
            className={classNames(
              values.is_barcode === 2 ? "hidden" : null,
              "mt-3 grid grid-cols-2 gap-4",
            )}
          >
            <div>
              <Input
                label="Lot number"
                name="lot_number"
                onChange={handleInputChange}
                value={values.lot_number}
                labelOn={true}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
                error={errors.lot_number}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-3">
            <div>
              <Input
                label="Unit cost"
                name="unit_cost"
                onChange={handleInputChange}
                value={values.unit_cost}
                labelOn={true}
                type="number"
                min="0"
                step="0.0001"
                prefix="$"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
                error={errors.unit_cost}
              />
            </div>
            <div>
              <Input
                label="Received quantity"
                name="received_amount"
                onChange={handleInputChange}
                value={values.received_amount}
                labelOn={true}
                type="number"
                min="0"
                step="any"
                suffix={unitOfMeasureLabel}
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
                error={errors.received_amount}
              />
            </div>
            <div>
              <Input
                label="Total cost"
                name="total_cost"
                value={
                  totalCost == null
                    ? "—"
                    : totalCost.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                }
                prefix="$"
                disabled={true}
                labelOn={true}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <div>
              <Input
                label="Product temperature"
                name="product_temperature"
                onChange={handleInputChange}
                value={values.product_temperature}
                labelOn={true}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
                error={errors.product_temperature}
              />
            </div>
            <div>
              <SelectMenu
                handleInputChange={handleInputChange}
                name="product_condition"
                options={conditionTypes}
                defaultValue={values.product_condition}
                value={values.product_condition}
                title="Product condition"
                error={errors.product_condition}
              />
            </div>
            <div>
              <SelectMenu
                handleInputChange={handleInputChange}
                name="product_quality"
                options={conditionTypes}
                value={values.product_quality}
                title="Product quality"
                error={errors.product_quality}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-4">
            <div>
              <SelectMenu
                handleInputChange={handleInputChange}
                name="pallet_condition"
                options={conditionTypes}
                value={values.pallet_condition}
                title="Pallet condition"
                error={errors.pallet_condition}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-4">
            <button
              type="button"
              className="print-button rounded-md bg-white px-3 py-2 text-sm font-semibold text-[#0F172A] shadow-sm ring-1 ring-inset ring-[#E2E8F0] hover:ring-[#2563EB]"
              onClick={() => generateBarcodeStringClicked()}
            >
              {createBarcodeInProgress ? (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              ) : (
                "Print label"
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-xl border border-[#2563EB] bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#1D4ED8] hover:bg-[#1D4ED8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2563EB]"
          onClick={handleSubmit}
          disabled={updateInProgress}
        >
          {updateInProgress ? (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : null}
          Save
        </button>
      </div>
    </div>
  );
}
